import { Translate } from '@src/i18n/useTranslate';

import { z } from 'zod';
import { meetsPasswordStrength, passwordsMatch, PASSWORD_MIN_LENGTH } from '@src/domains/customers';

export const schema = (t: Translate['i18n']) => {
  const requiredMessage = t('direct_link_required_field');

  const requiredStringField = z.string({ required_error: requiredMessage }).nonempty({ message: requiredMessage });

  return z
    .object({
      newPassword: requiredStringField.min(PASSWORD_MIN_LENGTH, t('direct_link_min_password_length')),
      newPasswordConfirmation: requiredStringField.min(PASSWORD_MIN_LENGTH, t('direct_link_min_password_length')),
    })
    .superRefine(({ newPassword, newPasswordConfirmation }, ctx) => {
      if (!passwordsMatch(newPassword, newPasswordConfirmation)) {
        ctx.addIssue({
          code: 'custom',
          message: t('direct_link_change_password_password_match'),
          path: ['newPasswordConfirmation'],
        });
      }

      if (!meetsPasswordStrength(newPassword)) {
        ctx.addIssue({
          code: 'custom',
          message: t('direct_link_password_strength'),
          path: ['newPassword'],
        });
      }
    })
    .transform((data) => {
      return {
        newPassword: data.newPassword,
        newPasswordConfirmation: data.newPasswordConfirmation,
      };
    });
};
